import stc from 'string-to-color';
import md5 from 'md5';

const textToColor = text => stc(md5(text));

export default textToColor;



// WEBPACK FOOTER //
// ./src/modules/shared/utils/textToColor.js